import { render, staticRenderFns } from "./app_bar_account.vue?vue&type=template&id=510ec8ae&scoped=true&"
import script from "./app_bar_account.vue?vue&type=script&lang=js&"
export * from "./app_bar_account.vue?vue&type=script&lang=js&"
import style0 from "./app_bar_account.vue?vue&type=style&index=0&id=510ec8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ec8ae",
  null
  
)

export default component.exports